import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import apiPath from "../../../utils/apiPath";
import { apiGet } from "../../../utils/apiFetch";
import useToastContext from "hooks/useToastContext";
import OFile from "components/reusable/OFile";
import helper from "../../../utils/helpers";
import { BiArrowBack } from "react-icons/bi";
import OImage from "components/reusable/OImage";
const View = (item) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [is_redirect, setRedirect] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(
    location?.state?.item?.files || null
  );
  const navigate = useNavigate();
  const [editData, setEditData] = useState(location.state?.item);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      itemName: editData?.itemName,
      itemPrice: editData?.itemPrice,
      description: editData?.description,
      status: editData?.status,
      categoryId: editData?.categoryDetails?.title,
      subCategoryId: editData?.subCategoryDetails?.title,
      createdAt: helper?.dateFormat(editData?.createdAt) || t("O_N/A"),
    },
  });

  const getBack = () => {
    setRedirect(true);
    navigate("/users/customer-view", {state: { from: 'sold_item_list', userDetails: location.state.userDetails}});
  };

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <span
          className="flex  items-center cursor-pointer"
          onClick={() => getBack()}
        >
          <BiArrowBack className="h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2" />
          <span className="ml-2">{t("O_BACK")}</span>
        </span>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                  <input
                    type="text"
                    name="itemName"
                    id="itemName"
                    disabled
                    className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    maxLength={31}
                    {...register("itemName")}
                  />

                <label
                  htmlFor="itemName"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_ITEM_NAME")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                  <input
                    type="text"
                    name="categoryId"
                    id="categoryId"
                    disabled
                    className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    maxLength={31}
                    {...register("categoryId")}
                  />

                <label
                  htmlFor="categoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORIES")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                  <input
                    type="text"
                    name="subCategoryId"
                    id="subCategoryId"
                    disabled
                    className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    maxLength={31}
                    {...register("subCategoryId")}
                  />

                <label
                  htmlFor="subCategoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_SUBCATEGORIES")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                  <input
                    type="text"
                    name="itemPrice"
                    id="itemPrice"
                    disabled
                    className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    maxLength={31}
                    {...register("itemPrice")}
                  />

                <label
                  htmlFor="itemPrice"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_ITEM_PRICE")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            
            <div className="mb-6">
              <div className="relative z-0   w-full group">
                <textarea
                  disabled
                  type="text"
                  name="description"
                  id="description"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  maxLength={151}
                  {...register("description")}
                />
                <label
                  htmlFor="description"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_DESCRIPTION")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">

              <div className="mb-3">
                <div className="">
                  <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                  {t("UPLOADED_IMAGE")}
                  </h3>
                </div>
                {editData.image ? (
                <div className="relative grid grid-cols-1 text-center">
                      <div>
                        <a href={editData.image} target="_blank" rel="noreferrer">
                          <OImage
                            // type={item?.type}
                            src={editData.image}
                            fallbackUrl="/images/imagesBanner.png"
                            alt=""
                            className="w-[400px] h-auto border relative inline"
                          />
                        </a>
                      </div>
                </div>
            ) : t("O_N/A")}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
